// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1phS-","log":"ModalInventoryLogs_log__2Ljsj","date":"ModalInventoryLogs_date__1ffhM","userName":"ModalInventoryLogs_userName__1YPKb"};